import { InsuranceHero } from "../shared/InsuranceHero";

export const BusinessHero = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Business Insurance",
    "serviceType": "Insurance",
    "category": "Business Insurance",
    "provider": {
      "@type": "InsuranceAgency",
      "name": "Allen Insurance Agency",
      "areaServed": "Illinois"
    },
    "description": "Comprehensive business insurance solutions including liability, property, and workers compensation coverage.",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <InsuranceHero
      title="Business Insurance Solutions"
      description="Protect your business with comprehensive coverage tailored to your industry needs. We help you manage risks and focus on growth."
      jsonLd={jsonLd}
    />
  );
};